// _basic/vm-view
import { useState } from 'react';
import { startLoading, stopLoading } from 'src/utils/loading';
import { useListStore, useListIds } from 'src/hooks/use-list-table';
import { useListSearch } from 'src/hooks/use-list-search';
import { getItems, getItemById } from './data';

export const useItemsSearch = () => {
  return useListSearch();
};
export const useItemsIds = () => {
  return useListIds();
};

class MyApi {
  /**
   * Combined function to get items or my items
   */
  getItemsCommon(searchState, fetchFunction) {
    const [state, setState] = useState({
      items: [], loading: false,
    });

    useListStore(searchState, (payload, isMounted) => {
      setState((prev) => ({ ...prev, loading: true }));
      startLoading();

      fetchFunction(
        payload,
        (endPoint) => {
          setState((prev) => ({ ...prev, endpoint: endPoint }));
        },
        (results) => {
          if (isMounted) {
            setState((prev) => ({ ...prev, items: results ?? [], loading: false }));
            stopLoading();
          }
        },
        () => {
          if (isMounted) {
            setState((prev) => ({ ...prev, items: [], loading: false }));
            stopLoading();
          }
        },
      );
    });

    return {
      ...state,
      query: searchState.filters.query,
    };
  }

  /**
   * List of items
   */
  getList(searchState) {
    return this.getItemsCommon(searchState, getItems);
  }

  /**
   * Item by id
   */
  async getDetail(payload) {
    const { result, error } = await getItemById(payload);
    // TODO handle result and error if need
    return { result, error };
  }
}

export const myApi = new MyApi();

/** Help_Desk */
// import { useListIds } from 'src/hooks/use-list-table';
// import { useListSearch } from 'src/hooks/use-list-search';
// import { useItemsStore } from 'src/hooks/use-items-store';

// getItems(searchState) { 
//   return useItemsStore(searchState, getItems); 
// }

// getDetail(payload, onSuccess) {
//   getItemById(payload).then((result) => {
//     onSuccess(result);
//   });
// }
